import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import {
    cancelOrderApi,
    labDashboardAPI,
    labOrderListAPI,
    pharmacyDashboardAPI,
    pharmacyDashboardOrdersAPI,
    updateOrderStatusAPI,
    updateSampleStatusAPI,
} from "../../api/pahrmacy";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Button,
    Col,
    Icon,
    Row,
} from "../../components/Component";
import RecentOrders from "../../components/partials/default/recent-orders/RecentOrders";
import OrderRecent from "../../components/partials/default/recent-orders/OrderRecent";
import StoreStatistics from "../../components/partials/default/StoreStatistics";
import Customer from "../../components/partials/e-commerce/customers/Customer";
import Orders from "../../components/partials/e-commerce/orders/Orders";
import TotalSales from "../../components/partials/e-commerce/total-sales/TotalSales";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import useLogout from "../../hooks/useLogout";
import CancelOrderModal from "../../MyComp/UI/modals/CancelOrderModal";
import { decrypt } from "../../utils/Utils";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import LabOrderData from "../../MyComp/UI/MyPrint/LabOrderData";
import PharmacyOrder from "../../components/partials/default/recent-orders/PharmacyOder";
import { tellecallerDashBoard } from "../../api/TellecallerUser";
import { telecallerOrderList } from "../../api/pahrmacy";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const PharmacyOrderUser = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout } = useLogout();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(10);

    // Change Page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        clearErrors,
        reset,
        setError,
        getValues,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isLoading: true,
            tableLoading: true,
            orderData: [],
            cardData: [],
            salesData: [],
            orders: [],
            customerData: [],
            storeStats: [],
            limit: 10,

            mode: location?.state?.mode || "Add",
            actionType: null,
        },
    });
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [onSearch, setonSearch] = useState(false);
    const [onSearchText, setSearchText] = useState("");
    const [imageOpen, setImageOpen] = useState(false);
    const isLoading = watch("isLoading");
    const tableLoading = watch("tableLoading");
    const orderData = watch("orderData");
    const salesData = watch("salesData");
    const storeStats = watch("storeStats");
    const orders = watch("orders");
    const limit = watch("limit");
    const customerData = watch("customerData");
    const user = decrypt(localStorage.getItem("userDetail"));
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRow1, setSelectedRow1] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const totalPages = Math.ceil(limit / itemPerPage);

    // const location = useLocation();

    const userId =
        location?.state?.userId ||
        location?.state?.id ||
        localStorage.getItem("userId"); // fallback

    // const userName = localStorage.getItem("userName")
    let userName = location?.state?.name;
    let labId = location?.state?.labId;

    useEffect(() => {
        if (user?.role == "lab") {
            setValue("user", user?.name);
            setValue("id", user?.id);
            console.log("yser--------->", user);
        }
    }, []);
    console.log("lab name", watch("id"), watch("user"));

    const cardData = watch("cardData");



    const handleClick = (status) => {
        if (status === "total") return;
        navigate("/telecaller-orders", {
            state: { status },
        });
    };

    console.log("ssss", statusData);

    useEffect(() => {
        const labIDValue = labId || user?.id;

        if (!labIDValue) return;

        const body = {
            search: debouncedSearch,
            page: currentPage,
            limit: itemPerPage,
            labId: labIDValue,
            userId: userId, // ✅ ADD THIS
        };

        getOrders(body);
    }, [debouncedSearch, currentPage, itemPerPage, labId, location]);

    const getOrders = (body) => {
        setValue("tableLoading", true); // ✅ added

        pharmacyDashboardOrdersAPI(body)
            .then((res) => {
                if (res.data.status === true) {
                    toast.clearWaitingQueue();
                    const dashboard = res?.data?.data;

                    setValue("isLoading", false);

                    // ✅ FIXED
                    setValue("limit", res?.data?.data?.totalOrders || 1);
                    console.log("Orders API Data:", res.data.data);
                    setValue("orderData", res.data.data);
                    setValue("tableLoading", false);
                } else if (res.data.status === false) {
                    setValue("tableLoading", false);
                    setValue("cityDD", []);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    setValue("tableLoading", false);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                setValue("tableLoading", false);
            });
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(onSearchText);
        }, 500); // 500ms debounce delay

        return () => {
            clearTimeout(handler);
        };
    }, [onSearchText]);

    const onOrderClick = (item) => {
        const body = {
            orderId: item?.id,
            userId: item?.userId,
        };
        navigate("/order-details", { state: body });
    };

    const onViewClick = (item) => {
        const body = {
            orderId: item?.id,
            userId: item?.userId,
        };
        navigate("/Lab-Order", { state: body });
    };
    const [showModal, setShowModal] = useState(false);

    const [selectedRow, setSelectedRow] = useState(false);
    const toggleCancelOrder = (item) => {
        setShowModal(true);
        setSelectedRow(item);

        console.log(item, "item");
    };

    const handleCancelOrder = (reason) => {
        if (!selectedRow) return;
        console.log(selectedRow, "selectedRow");

        const payload = {
            orderId: selectedRow?.id,
            remark: reason,
            mobile: selectedRow?.mobile,
        };

        console.log("Confirmed cancel order:", payload);

        cancelOrderApi(payload)
            .then((res) => {
                if (res.data.status === true) {
                    toast.success(res.data.message);
                    toast.clearWaitingQueue();
                    setShowModal(false);
                    const body = {
                        search: debouncedSearch,
                        page: currentPage,
                        limit: itemPerPage,
                        // pharmacyId: location?.state?.pharmacyId,
                        labId: location.state.labId,
                        userId: userId, // ✅ ADD HERE ALSO
                    };

                    getOrders(body);
                } else if (res.data.status === false) {
                    // toast.error(res.data.message);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message);
            });
    };

    const renderSparkline = (values = [], color = "primary") => {
        if (!Array.isArray(values) || values.length === 0) {
            return null; // or return empty svg
        }

        const max = Math.max(...values);
        const min = Math.min(...values);

        const points = values
            .map((v, i) => {
                const x = (i / (values?.length - 1)) * 100;
                const y = 30 - ((v - min) / (max - min || 1)) * 30;
                return `${x},${y}`;
            })
            .join(" ");

        return (
            <svg width="90" height="30" viewBox="0 0 100 30">
                <polyline fill="none" stroke={`var(--bs-${color})`} strokeWidth="2" points={points} />
            </svg>
        );
    };

    //   const KPICardSkeleton = () => (
    //     <div className="col-xl-4 col-md-6">
    //       <div className="card shadow-sm h-100 p-3">
    //         <div className="card-body d-flex justify-content-between align-items-center">
    //           <Skeleton height={14} width={120} className="mb-2" />
    //           <Skeleton height={24} width={80} />
    //         </div>
    //       </div>
    //     </div>
    //   );

    //   const MiddleCardSkeleton = ({ height = 220 }) => (
    //     <div className="card shadow-sm h-100 p-4">
    //       <Skeleton width={120} height={10} className="mb-3" />
    //       <Skeleton width={180} height={40} className="mb-3" />
    //       <Skeleton width={180} height={10} className="mb-3" />

    //       <Skeleton width={180} height={15} className="mb-3" />

    //       <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
    //         <Skeleton width={180} height={15} className="mb-3" />
    //         <Skeleton width={40} height={10} className="mb-3" />
    //       </div>
    //       <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
    //         <Skeleton width={180} height={40} className="mb-3" />
    //         <Skeleton width={80} height={15} className="mb-" />
    //       </div>

    //       <div className="mt-5">
    //         <Skeleton width="100%" height={30} borderRadius={6} />
    //       </div>
    //     </div>
    //   );

    //   const MiddleCardStatic = ({ height = 120 }) => {
    //     return (
    //       <div className="card card-bordered h-100">
    //         <div className="card-inner">
    //           {/* Title */}
    //           <Skeleton width={120} height={18} />

    //           <div className="mt-3">
    //             {[1, 2, 3, 4].map((_, idx) => (
    //               <div key={idx} className="d-flex justify-content-between align-items-center mb-3">
    //                 {/* Left text */}
    //                 <div>
    //                   <Skeleton width={100} height={14} />
    //                   <Skeleton width={30} height={18} className="mt-1" />
    //                 </div>

    //                 {/* Right icon box */}
    //                 <Skeleton width={40} height={40} borderRadius={8} />
    //               </div>
    //             ))}
    //           </div>
    //         </div>
    //       </div>
    //     );
    //   };

    //   const MiddleCardOrder = ({ height = 100 }) => {
    //     return (
    //       <div className="card card-bordered h-100">
    //         <div className="card-inner">
    //           {/* Top row */}
    //           <div className="mt-2">
    //             <Skeleton width={80} height={18} />
    //           </div>

    //           {/* Main number */}
    //           <div className="d-flex justify-content-between align-items-start">
    //             <Skeleton width={60} height={36} />
    //             <div className="text-end">
    //               <Skeleton width={40} height={14} />
    //               <Skeleton width={80} height={14} className="mt-1" />
    //             </div>
    //           </div>

    //           {/* Chart placeholder */}
    //           <div className="mt-3">
    //             <Skeleton width="100%" height={30} borderRadius={6} />
    //           </div>
    //         </div>
    //       </div>
    //     );
    //   };

    const RecentOrdersSkeleton = ({ rows = 6 }) => {
        return (
            <div className="card card-bordered">
                {/* Header */}
                <div className="card-inner d-flex justify-content-between align-items-center">
                    <Skeleton width={150} height={22} />
                    <div className="d-flex gap-3">
                        <Skeleton width={24} height={24} circle />
                        <Skeleton width={24} height={24} circle />
                    </div>
                </div>

                {/* Table */}
                <div className="nk-tb-list is-separate">
                    {/* Table Head */}
                    <div className="nk-tb-item nk-tb-head">
                        {Array.from({ length: 8 }).map((_, i) => (
                            <div className="nk-tb-col" key={i}>
                                <Skeleton width={80} height={14} />
                            </div>
                        ))}
                    </div>

                    {/* Rows */}
                    {Array.from({ length: rows }).map((_, idx) => (
                        <div className="nk-tb-item" key={idx}>
                            {/* Order No */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Customer */}
                            <div className="nk-tb-col">
                                <div className="d-flex align-items-center gap-2">
                                    <Skeleton width={36} height={36} circle />
                                    <Skeleton width={120} height={14} />
                                </div>
                            </div>

                            {/* Date */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Amount */}
                            <div className="nk-tb-col">
                                <Skeleton width={60} height={14} />
                            </div>

                            {/* Address */}
                            <div className="nk-tb-col">
                                <Skeleton width={180} height={14} />
                            </div>

                            {/* Purchased */}
                            <div className="nk-tb-col">
                                <Skeleton width={180} height={14} />
                            </div>

                            {/* Pharmacy */}
                            <div className="nk-tb-col">
                                <Skeleton width={90} height={14} />
                            </div>

                            {/* Status */}
                            <div className="nk-tb-col">
                                <Skeleton width={70} height={14} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };
    const updateOrderStatus = (item) => {
        console.log("order", item);
        const payload = {
            orderId: item?.id,
            status: item?.next_status,
        };

        updateOrderStatusAPI(payload)
            .then((res) => {
                if (res.data.status === true) {
                    toast.success(res.data.message);
                    toast.clearWaitingQueue();
                    setIsOpen(false);
                    const body = {
                        search: debouncedSearch,
                        page: currentPage,
                        limit: itemPerPage,
                        labId: location?.state?.labId,
                        userId: userId, // ✅ ADD HERE ALSO
                    };

                    getOrders(body);
                } else if (res.data.status === false) {
                    // toast.error(res.data.message);
                    toast.clearWaitingQueue();
                } else if (res.data.status === "expired") {
                    // toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                }
            })
            .catch((err) => {
                // toast.error(err?.response?.data?.message);
            });
    };

    const updateSampleStatus = (data) => {
        setIsOpen(true);
        setSelectedRow(data);
    };
    const handleSampleStatusUpdate = async () => {
        if (!selectedRow) return;

        const payload = {
            orderId: selectedRow?.id,
            labId: selectedRow?.lab_id || selectedRow?.labId,
            status: selectedRow?.next_status,
        };

        try {
            const res = await updateSampleStatusAPI(payload);

            if (res?.data?.status) {
                toast.success("Sample status updated successfully");

                const body = {
                    search: debouncedSearch,
                    page: currentPage,
                    limit: itemPerPage,
                    labId: location?.state?.labId,
                    userId: userId, // ✅ ADD HERE ALSO
                };
                getOrders(body);
                setIsOpen(false);
            } else {
                toast.error(res?.data?.message || "Failed to update sample status");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };

    const getTelecallerDashboard = () => {
        setValue("isLoading", true);

        const body = {
            userId: user?.id || userId,
        };

        tellecallerDashBoard(body)
            .then((res) => {
                if (res?.data?.status) {
                    const data = res?.data?.data;

                    console.log("Dashboard Data:", data);

                    // Directly set (already array)
                    setValue("cardData", data?.cardData || []);

                    setValue("isLoading", false);
                } else if (res?.data?.status === "expired") {
                    logout();
                } else {
                    setValue("isLoading", false);
                }
            })
            .catch((err) => {
                console.error(err);
                setValue("isLoading", false);
            });
    };

    useEffect(() => {
        if (user?.id || userId) {
            getTelecallerDashboard();
        }
    }, []);

    return (
        <>
            <Head title={"User Pharmacy Orders"} />
            <Content>
                <BlockHead size={`sm`}>
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3" className={"text-capitalize"}>
                                {watch("user")} {"User Pharmacy Orders"}
                            </BlockTitle>
                        </BlockHeadContent>
                        {user?.role == "admin" && (
                            <BlockHeadContent>
                                <div className="">
                                    <Button
                                        color="primary"
                                        outline
                                        className={`  me-n1`}
                                        onClick={() => {
                                            navigate("/users");
                                        }}
                                    >
                                        <Icon name={"arrow-left"} />
                                    </Button>
                                </div>

                            </BlockHeadContent>
                        )}
                    </BlockBetween>
                </BlockHead>
                <Block>
                    <Row className="g-gs">

                        <Col xxl="4">
                            <Row className="g-gs">

                            </Row>
                        </Col>{" "}
                        <Col xxl="12">
                            {tableLoading ? (
                                <RecentOrdersSkeleton rows={6} />
                            ) : (
                                // <OrderRecent
                                //   setSearchText={setSearchText}
                                //   onSearchText={onSearchText}
                                //   onSearch={onSearch}
                                //   setonSearch={setonSearch}
                                //   data={orderData?.orders || orderData || []}// ✅ FIXED
                                //   limit={limit}
                                //   setItemPerPage={setItemPerPage}
                                //   itemPerPage={itemPerPage}
                                //   paginate={paginate}
                                //   currentPage={currentPage}
                                //   isLoading={tableLoading}
                                //   onOrderClick={onOrderClick}
                                //   toggleCancelOrder={toggleCancelOrder}
                                //   updateOrderStatus={updateOrderStatus}
                                //   isOpen={isOpen}
                                //   setIsOpen={setIsOpen}
                                //   setSelectedRow={setSelectedRow1}
                                //   selectedRow={selectedRow1}
                                // />
                                <PharmacyOrder
                                    setSearchText={setSearchText}
                                    onSearchText={onSearchText}
                                    onSearch={onSearch}
                                    setonSearch={setonSearch}
                                    data={orderData?.orders}
                                    limit={limit}
                                    setItemPerPage={setItemPerPage}
                                    itemPerPage={itemPerPage}
                                    paginate={paginate}
                                    currentPage={currentPage}
                                    isLoading={tableLoading}
                                    onOrderClick={onOrderClick}
                                    onViewClick={onViewClick}
                                    toggleCancelOrder={toggleCancelOrder}
                                    updateOrderStatus={updateOrderStatus}
                                    isOpen={isOpen}
                                    setIsOpen={setIsOpen}
                                    setSelectedRow={setSelectedRow1}
                                    selectedRow={selectedRow1}
                                />
                            )}
                        </Col>
                    </Row>
                </Block>
            </Content>
            <CancelOrderModal
                isOpen={showModal}
                toggle={() => setShowModal(!showModal)}
                onConfirm={handleCancelOrder}
                item={selectedRow}
            />
        </>
    );
};

export default PharmacyOrderUser;
